import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import CourseDetails from "./pages/CourseDetails";
import CourseAdmin from "./pages/CourseAdmin";
import config from "./config/environment";
// TailwindCSS is loaded via `src/index.css`

// Enhanced scroll reset component
function EnhancedScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Force scroll to top immediately
    window.scrollTo(0, 0);
    
    // Also reset on document elements
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
    
    // Additional reset with timeout to catch any late DOM updates
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    }, 50);

    // Additional aggressive reset
    const aggressiveTimer = setTimeout(() => {
      // Try multiple scroll reset methods
      window.scrollTo(0, 0);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
      
      // Reset all possible scroll containers
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
        document.documentElement.scrollLeft = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
        document.body.scrollLeft = 0;
      }
      
      // Force scroll on window
      window.scrollY = 0;
      window.scrollX = 0;
    }, 100);

    return () => {
      clearTimeout(timer);
      clearTimeout(aggressiveTimer);
    };
  }, [location.pathname]);

  // Also handle page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Reset scroll position before page unload
      window.scrollTo(0, 0);
    };

    const handleLoad = () => {
      // Reset scroll position after page load
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return null;
}

function App() {
  return (
    <Router>
      <EnhancedScrollToTop />
      <Navbar />
              <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<CourseDetails />} />
          {/* Admin routes only available in development */}
          {config.get('showAdminPanel') && (
            <Route path="/admin/courses" element={<CourseAdmin />} />
          )}
        </Routes>
      <Footer />
    </Router>
  );
}

export default App;
